import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Hook to prevent navigation when there's unsaved form data
 * Shows browser warning before leaving page
 */
export const usePreventNavigation = (hasUnsavedData = false, message = 'You have unsaved changes. Are you sure you want to leave?') => {
  const location = useLocation()
  const hasUnsavedRef = useRef(hasUnsavedData)

  // Update ref when hasUnsavedData changes
  useEffect(() => {
    hasUnsavedRef.current = hasUnsavedData
  }, [hasUnsavedData])

  // Note: useBlocker is not available in React Router v6, using beforeunload instead

  // Handle beforeunload (browser tab close/refresh)
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedRef.current) {
        e.preventDefault()
        e.returnValue = message
        return message
      }
    }

    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [message])

  // Handle visibility change (tab switching)
  useEffect(() => {
    const handleVisibilityChange = () => {
      // When tab becomes visible, check if we need to restore data
      if (document.visibilityState === 'visible' && hasUnsavedRef.current) {
        // Data should be persisted in localStorage, so we just log
        console.log('Tab visible - unsaved data should be in localStorage')
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])

  return null
}

